// Generated by CoffeeScript 2.7.0
import Bootloader from './base.js';

Bootloader.afterInitialize = function() {
  Skylark.Elements.Pagination.init();
  return Skylark.Elements.ButtonDropdown.init();
};

export default Bootloader;
